const l = {
  name: "KeyGroup",
  dimensions: { width: 40, height: 40 },
  content: `
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 40 40" style="enable-background:new 0 0 40 40;" xml:space="preserve">
<style type="text/css">
	.st0{fill: currentColor;}
</style>
<g>
	<g>
		<path class="st0" d="M11,4C9.1,4,7.5,5.6,7.5,7.5S9.1,11,11,11c1.9,0,3.5-1.6,3.5-3.5S12.9,4,11,4z M9.5,7.5C9.5,6.7,10.2,6,11,6
			c0.8,0,1.5,0.7,1.5,1.5S11.8,9,11,9C10.2,9,9.5,8.3,9.5,7.5z"/>
		<path class="st0" d="M11,0C4.9,0,0,4.9,0,11c0,4.7,2.9,8.7,7,10.2v5.2L8.6,28l-2,2l2,2L7,33.6v2.9l4,3.5l4-3.5V21.2
			c0.1-0.1,0.3-0.1,0.4-0.2l3.7,3.7h2.2v2.8h2.8v2.2l2,2l5.3-0.3l0.3-5.3L21.1,15.4c0.1-0.1,0.1-0.3,0.2-0.4h5.2l1.6-1.6l2,2l2-2
			l1.6,1.6h2.9l3.5-4l-3.5-4H21.2C19.6,2.9,15.7,0,11,0z M19.6,8.2C19.6,8.3,19.6,8.3,19.6,8.2c0,0.1,0,0.1,0,0.1
			C19.9,9.2,20,10.1,20,11c0,4-2.6,7.4-6.3,8.6L13,19.8v15.7l-2,1.8l-2-1.8v-1.1l2.4-2.4l-2-2l2-2L9,25.6v-5.8l-0.7-0.2
			C4.6,18.4,2,15,2,11c0-5,4-9,9-9C15,2,18.4,4.6,19.6,8.2z M21.8,9h13.7l1.8,2l-1.8,2h-1.1L32,10.6l-2,2l-2-2L25.6,13h-3.8
			c0.1-0.6,0.2-1.3,0.2-2C22,10.3,21.9,9.6,21.8,9z M20.1,17.2l9.7,9.7l-0.2,2.7l-2.7,0.2L26.1,29v-3.4h-2.8v-2.8h-3.4l-2.7-2.7
			C18.3,19.3,19.3,18.3,20.1,17.2z"/>
	</g>
</g>
</svg>
  `
};
export {
  l as KeyGroup
};
